import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { Coupon, CouponDetails, CouponResponse } from './models/coupon.model';
import { CouponsFilter } from './models/coupons-filter.model';

@Injectable()
export class CouponsService {
  constructor(private requestService: RequestService) {}

  async getCoupons(storeUuid: string, filter: CouponsFilter): Promise<CouponResponse> {
    let urlRequest: string = this.requestService.buildUrlPathParams(
      { uuid: storeUuid },
      APP_CONFIG.WEBSERVICE.STORE_COUPONS
    );
    urlRequest += '?' + this.requestService.buildUrlParams(filter);
    let response: CouponResponse = await this.requestService.getData(urlRequest);

    const coupons: Array<Coupon> = [];
    if (response && response.data && response.data.length > 0) {
      response.data.forEach((item) => {
        coupons.push(new Coupon(item));
      });
    }
    response.data = coupons;
    return response;
  }

  async getCouponDetails(storeUuid: string, couponId: number): Promise<CouponDetails> {
    const urlRequest: string = this.requestService.buildUrlPathParams(
      { uuid: storeUuid, couponId: couponId },
      APP_CONFIG.WEBSERVICE.COUPON_DETAILS
    );
    return await this.requestService.getData(urlRequest);
  }

  async saveCoupon(storeUuid: string, coupon: Coupon): Promise<void> {
    console.log(coupon.toJson());
    const urlRequest: string = this.requestService.buildUrlPathParams(
      { uuid: storeUuid },
      APP_CONFIG.WEBSERVICE.STORE_COUPONS
    );
    if (coupon.id) {
      return await this.requestService.putData(urlRequest, coupon.toJson());
    }
    return await this.requestService.postData(urlRequest, coupon.toJson());
  }

  async removeCoupon(storeUuid: string, couponId: number): Promise<void> {
    const urlRequest: string = this.requestService.buildUrlPathParams(
      { uuid: storeUuid },
      APP_CONFIG.WEBSERVICE.STORE_COUPONS
    );
    return await this.requestService.deleteData(`${urlRequest}/${couponId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/coupons.service.ts